import { z } from 'zod';
import {
  IsoDate,
  IsoDateTime,
  MoneyAmount,
  PositiveDecimalString,
  UuidString,
} from '../primitives.js';

/**
 * S20 — Project Task Log (minimal timesheet).
 * Альтернатива полному ERPNext Timesheet — без ActivityType picker.
 * Driver labor cost в engine P8.3.
 */

export const ProjectTaskLog = z
  .object({
    id: UuidString,
    entity_id: UuidString,
    task_id: UuidString,
    project_id: UuidString,
    user_id: UuidString,
    /** JOIN enrichment (P14.1) — для FE G12.1 без отдельного users-query. */
    user_name: z.string().nullable().optional(),
    log_date: IsoDate,
    hours: PositiveDecimalString,
    description: z.string().nullable(),
    /**
     * Снимок ставки на момент записи (PLM-1, B13): производное оклада сотрудника.
     * `null` — оклада на момент записи не было; такие часы метрики считают отдельно
     * (`labor_rate_missing_*`), задним числом не резолвятся (В-26).
     */
    costing_rate: MoneyAmount.nullable().optional(),
    costing_amount: MoneyAmount.nullable().optional(),
    created_at: IsoDateTime,
    updated_at: IsoDateTime,
  })
  .passthrough();
export type ProjectTaskLog = z.infer<typeof ProjectTaskLog>;

export const ProjectTaskLogUpsertInput = z.object({
  task_id: UuidString,
  log_date: IsoDate,
  hours: PositiveDecimalString,
  description: z.string().nullable().optional(),
});
export type ProjectTaskLogUpsertInput = z.infer<typeof ProjectTaskLogUpsertInput>;
